export const semanticTokens = {
  colors: {
    // Background tokens - warm off-white tones
    'bg.canvas': {
      default: '#FFFBF7',
      _dark: '#1A1412',
    },
    'bg.elevated': {
      default: '#FFFFFF',
      _dark: '#231C18',
    },
    // Text tokens - high contrast
    'text.primary': {
      default: '#1C1917',
      _dark: '#FAFAF9',
    },
    'text.muted': {
      default: '#57534E',
      _dark: '#A8A29E',
    },
    // Border tokens - warm gray tones
    'border.muted': {
      default: '#E7E5E4',
      _dark: '#292524',
    },
    'border.emphasized': {
      default: '#D6D3D1',
      _dark: '#44403C',
    },
    // Primary accent - orange/red brand color
    'accent.default': {
      default: '#EA580C',
      _dark: '#FB923C',
    },
    'accent.on': {
      default: '#FFFFFF',
      _dark: '#1A1412',
    },
    // Accent hover state
    'accent.hover': {
      default: '#C2410C',
      _dark: '#FDBA74',
    },
    // Secondary/muted accent for subtle highlights
    'accent.subtle': {
      default: '#FFF7ED',
      _dark: '#431407',
    },
    'accent.subtle.hover': {
      default: '#FFEDD5',
      _dark: '#7C2D12',
    },
    'bg.input': {
      default: '#FFFFFF',
      _dark: '#231C18',
    },
    'bg.disabled': {
      default: '#F5F5F4',
      _dark: '#1C1917',
    },
    'bg.subtle': {
      default: '#FAFAF9',
      _dark: '#292524',
    },
    'bg.subtle.hover': {
      default: '#FFF7ED',
      _dark: '#3D2F27',
    },
    'critical.bg': {
      default: '#FEE2E2',
      _dark: '#7F1D1D',
    },
    'critical.text': {
      default: '#B91C1C',
      _dark: '#FEE2E2',
    },
    'text.placeholder': {
      default: '#78716C',
      _dark: '#A8A29E',
    },
    'overlay.alpha': {
      default: 'rgba(28, 25, 23, 0.45)',
      _dark: 'rgba(10, 8, 6, 0.75)',
    },
    // Glass effect tokens - warm tones
    'glass.bg': {
      default: 'rgba(255, 251, 247, 0.84)',
      _dark: 'rgba(26, 20, 18, 0.7)',
    },
    'glass.border': {
      default: 'rgba(168, 162, 158, 0.35)',
      _dark: 'rgba(68, 64, 60, 0.6)',
    },
    'glass.fallback': {
      default: 'rgba(250, 250, 249, 0.94)',
      _dark: 'rgba(26, 20, 18, 0.82)',
    },
    // Chat bubble tokens - orange-tinted for user messages
    'chat.user.bg': {
      default: 'rgba(234, 88, 12, 0.12)',
      _dark: 'rgba(251, 146, 60, 0.18)',
    },
    'chat.user.border': {
      default: 'rgba(234, 88, 12, 0.32)',
      _dark: 'rgba(251, 146, 60, 0.36)',
    },
    'chat.user.fallback': {
      default: 'rgba(234, 88, 12, 0.18)',
      _dark: 'rgba(251, 146, 60, 0.24)',
    },
    'goalPalette.0': {
      default: '#D3D3D3', // Light gray for better visibility against backgrounds
      _dark: '#E2E8F0',
    },
    'goalPalette.1': {
      default: '#BBF7D0',
      _dark: '#4ADE80',
    },
    'goalPalette.2': {
      default: '#FDE68A',
      _dark: '#FACC15',
    },
    'goalPalette.3': {
      default: '#FED7AA',
      _dark: '#FB923C',
    },
    'goalPalette.4': {
      default: '#FECACA',
      _dark: '#F87171',
    },
    'goalPalette.5': {
      default: '#E9D5FF',
      _dark: '#C084FC',
    },
    'completion.progress': {
      default: '#FF6B4A',
      _dark: '#FF8A6B',
    },
  },
  shadows: {
    'elevation.1': {
      default: '0 1px 2px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.04)',
      _dark: '0 1px 2px rgba(15, 23, 42, 0.18), 0 1px 3px rgba(15, 23, 42, 0.12)',
    },
    'elevation.2': {
      default: '0 12px 24px -10px rgba(15, 23, 42, 0.25), 0 8px 16px -8px rgba(15, 23, 42, 0.12)',
      _dark: '0 16px 32px -16px rgba(15, 23, 42, 0.32), 0 8px 20px -12px rgba(15, 23, 42, 0.18)',
    },
    glass: {
      default: '0 10px 30px rgba(15, 23, 42, 0.08)',
      _dark: '0 12px 34px rgba(2, 6, 23, 0.45)',
    },
  },
};
